import { render, staticRenderFns } from "./FootBottom.vue?vue&type=template&id=5ca78938&scoped=true"
import script from "./FootBottom.vue?vue&type=script&lang=js"
export * from "./FootBottom.vue?vue&type=script&lang=js"
import style0 from "./FootBottom.vue?vue&type=style&index=0&id=5ca78938&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca78938",
  null
  
)

export default component.exports